import React from 'react';
import './Loader.css'

const Loader = () => {
  return <div className="loader">
    <h1>CALAPES Loading...</h1>
  </div>;
};

export default Loader;